import { render, staticRenderFns } from "./MMinutes.vue?vue&type=template&id=360d05d5&scoped=true&"
import script from "./MMinutes.vue?vue&type=script&lang=js&"
export * from "./MMinutes.vue?vue&type=script&lang=js&"
import style0 from "./MMinutes.vue?vue&type=style&index=0&id=360d05d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d05d5",
  null
  
)

export default component.exports